import { useLayoutEffect, useRef } from "react"
import styles from "./EnvBanner.module.css"

/** Names the environment across the top of the page; hidden without a label. */
export function EnvBanner({ label }: { label: string | undefined }) {
  const ref = useRef<HTMLDivElement>(null)

  // Publish the banner's height as a root CSS variable so top-anchored fixed
  // elements (e.g. the kiosk cog) can offset below it. Unset in prod, where the
  // banner doesn't render, so those elements fall back to a 0px offset.
  useLayoutEffect(() => {
    if (!label) return
    const root = document.documentElement
    root.style.setProperty(
      "--env-banner-height",
      `${ref.current?.offsetHeight ?? 0}px`,
    )
    return () => {
      root.style.removeProperty("--env-banner-height")
    }
  }, [label])

  if (!label) return null
  return (
    <div ref={ref} aria-hidden="true" className={styles.banner}>
      {label}
    </div>
  )
}
